import React, { useEffect, memo } from "react";
import { TextResponse } from "pages/assistant/components/chat/components/responses/TextResponse";
import { CustomDataArtifactRecord } from "types/AssistantTypes";

type Props = {
  data: CustomDataArtifactRecord;
  onLoaded?: () => void;
  onPortfolio?: boolean;
};

export const FinecoPortfolioStoryArtifact = memo(
  ({ data, onLoaded, onPortfolio = false }: Props) => {
    useEffect(() => {
      onLoaded?.();
    }, [onLoaded]);

    const text = data?.story;

    if (!text) {
      return null;
    }
    return <TextResponse onPortfolio={onPortfolio} message={text} />;
  },
);

FinecoPortfolioStoryArtifact.displayName = "FinecoPortfolioStoryArtifact";

export default FinecoPortfolioStoryArtifact;
